import React from 'react';

interface FooterProps {

}
interface FooterState {
}
class Footer extends React.Component<FooterProps, FooterState> {
  constructor(props:FooterProps) {
    super(props);

    this.state = { };
  }


  render() {
    return <>

    <footer className="columns">
      <div className="column">
      <a target="_blank" href="https://get.sheet.rocks/privacy-policy">Privacy</a>
      <a target="_blank" href="https://get.sheet.rocks/terms-and-conditions">Terms</a>  
      </div>
      <div className="s-wordmark column">
        <img src="/img/wordmark.png" style={{ width: "15rem", maxHeight: "unset" }} />
      </div>
    </footer>
  </>
  }
}

export default Footer;
